import serviceMail from '@/services/notifications/apiMailer'

export const state = () => {}

export const mutations = {}

export const actions = {
  sendMail: async ({}, input) => serviceMail.sendMail(input.to, input.account, input.template, input.subject, input.content)
}
